import PropTypes from "prop-types";
import classNames from "classnames";
import { t } from "@/i18n-js/instance";
import { Icon } from "@circle-react/components/shared/Icon";
import { CircularProgress } from "@circle-react/components/shared/uikit/TipTap/AttachmentPreviews/CircularProgress";
import { useSmScreenMediaQuery } from "@circle-react/hooks/useMediaQuery";
import { Button } from "@circle-react-uikit/Button";
import { Typography } from "@circle-react-uikit/Typography";

export const MediaPickerContent = ({
  isUploading,
  isProcessingChecksum,
  progress,
  isDragActive,
  promptText,
  onSelectFile,
}) => {
  const isSmScreen = useSmScreenMediaQuery();

  if (isUploading || isProcessingChecksum) {
    return (
      <div className="flex flex-col items-center space-y-5">
        <CircularProgress percentage={progress} size={32} strokeWidth={3} />
        <Typography.LabelSm>
          {isProcessingChecksum
            ? t("tiptap.preparing")
            : t("courses.edit.lesson.upload_progress", {
                progress: progress.toFixed(0),
              })}
        </Typography.LabelSm>
      </div>
    );
  }

  return (
    <>
      <div className="text-dark flex flex-col justify-center gap-2">
        <div
          className={classNames("flex items-center justify-center space-x-2", {
            invisible: isDragActive,
          })}
        >
          <Icon
            height={24}
            width={24}
            viewBox="0 0 20 20"
            type="20-course-audio"
          />
          <Icon
            height={24}
            width={24}
            viewBox="0 0 20 20"
            type="20-course-video"
          />
        </div>
        <div className="text-center">
          {!isSmScreen && (
            <Typography.TitleMd>
              {t("courses.edit.lesson.featured_media")}
            </Typography.TitleMd>
          )}
          <Typography.BodySm>{promptText}</Typography.BodySm>
        </div>
      </div>
      <div
        className={classNames({
          invisible: isDragActive,
        })}
      >
        <Button type="button" onClick={onSelectFile} variant="secondary">
          {t("courses.edit.lesson.select_file")}
        </Button>
      </div>
    </>
  );
};

MediaPickerContent.propTypes = {
  isUploading: PropTypes.bool,
  progress: PropTypes.number,
  isDragActive: PropTypes.bool,
  promptText: PropTypes.string,
  onSelectFile: PropTypes.func,
};
